
import { generateClasses } from '@formkit/themes'
import { formkitExtension } from '@lib/pp-shop-lib'

export default {
    config: {
        plugins: [formkitExtension],
        classes: generateClasses({
            global: { // applies to all input types
                outer: 'fk-input'
            },
            radio: { // only applies to text input type
                input: '$reset uk-radio'
            },
            select: { // only applies to email input type
                input: '$reset uk-select'
            },
            number: {
                input: '$reset uk-input'
            }
        })
    }
}